export default __webpack_public_path__ + "static/media/signinimg.6fbf5b0f.png";